const splashScreenType = {
    FREE_PLAN: 'FREE_PLAN',
    PAID_PLAN: 'PAID_PLAN',
    UPGRADE_IN_PROGRESS: 'UPGRADE_IN_PROGRESS',
    CONTRACT_ACCEPTED: 'CONTRACT_ACCEPTED',
    AMS_CONTRACT: 'AMS_CONTRACT',
};

export default splashScreenType;